// https://vuex.vuejs.org/en/state.html

const getIdsReportes = () => {
    try {
        return JSON.parse(localStorage.getItem('idsReportes'));
    } catch (error) {
        return [];
    }
};

const getPreferenciasUsuario = () => {
    try {
        var preferencias = JSON.parse(localStorage.getItem('preferenciasUsuario')) || {};
        return preferencias;
    } catch (error) {
        return {};
    }
};

const safeBool = (key) => {
    return (localStorage.getItem(key) || "false") === "true";
};


export default {
    authStatus: '',
    token: localStorage.getItem('token') || '',
    user: localStorage.getItem('user') || '',
    routes: JSON.parse(localStorage.getItem('routes')),
    idUser: parseInt(localStorage.getItem('idUser')),
    idRol: parseInt(localStorage.getItem('idRol')),
    idsTurnos: [],
    preferenciasUsuario: getPreferenciasUsuario(),
    //0.- todos los reportes, 1.- reportes de sensores, 2.- reportes sin sensores
    tipoFiltroReportes: 2,
    //idsReportes: localStorage.getItem('idsReportes')!=null?JSON.parse(localStorage.getItem('idsReportes')):[],
    idsReportes: getIdsReportes(),
    //0.- todos los reportes, 1.- reportes de sensores, 2.- reportes sin sensores
    tipoFiltroReportes: 2,
    validado: (localStorage.getItem('validado') == null) ? true : localStorage.getItem('validado') == 'true',
    cambiarPassword: (localStorage.getItem('cambiarPassword') == null) ? false : localStorage.getItem('cambiarPassword') == 'true',
    desconocidos: true,
    desconocidosIds: [],
    netError: false,
    internetStatus: 0,
    nombreEmpresa: "Managrx",
    clavePersonalizada: false,
    calculadoraRollos: false,
    maquila: false,
    cargasMasivas: false,
    inventario: false,
    finalizarLabel: "Finalizar",
    pinLength: 4,
    loginOpsModo: 1,
    loginOpsLength: 8,
    pinType: "numbers",
    rfid: false,
    rutasAprendizaje: false,
    reporteAuxiliar: false,
    pantografo: true,
    anchoMaximo: "95%",
    qrOperador: false,
    mqtt: false,
    webPushKey: "BNc5fgO5KiglWjC3bc1hrnw2sPfuE4N1WXXxrxgBFZ2xwNTlIzW-pxKZIKIMIWrCtafbWh_BSmvDae36UWokPIA",
    colorTabs: "blue darken-3", //default: blue lighten-2 accent-4
    modoAyuda: JSON.parse(localStorage.getItem('modoAyuda') || false),
    numOTS: 10,
    trazabilidadInventario: true,
    movimientosFactura: false,
    blackDecker: false,
    listadoChips: false,
    iniciarAutoNuevaODT: false,
    demostracion: false,
    moldes: true,
    odtAgrupadas: false,
    operacionesCantidadCero: false,
    editarPzsNoOk: false,
    editarTiempoMuerto: false,
    salidasQR: false,
    cantidadObjetivoQR: false,
    oeeRendimientoLabel: "Rendimiento",
    linkTelegram: null,
    idSubAlmacen: -1,
    pausarActividadMtto: true,
    whatsapp: false,
    seleccionaUnaMaquina: false,  // se usa para que solo pueden seleccionar una sola maquina, si se encuentra en false tienen que seleccionar ambas maquinas
    mostrarChat: false, // mostrar chat en la pantalla
    nuevoReporteOee: false, // nuevo reporte OEE
    formulaNyx: false, // nueva formula para el calculo de OEE
    iniciarOTProduccionAuto: false, // iniciar ODT de produccion automaticamente
    ocultarLlamadoMantenimiento: false, // Oculta los ajustes de llamadas a mantenimiento en incidencias (tipos y subtipos)
    recetaIngredientesTC: false, // Agrega checkbox para las recetas con tiempo ciclo (en Subpasos, autocálculo para opera)
    autoCalcularTiemposReceta: false, // Nos permite autoreflejar datos de tiempo en los ingredientes (máquinas y operadores) en receta
    tiempoCicloPaso: false,  // Nos permite reflejar el total del tiempo de subpasos y la opción para calcular el tiempo de subpaso por piezas en cierto tiempo
    maquinaTokenSelect: false, //para automatización de reporteo DAQ
    habilitarMultiMaquina: true, // Nos permite que una odt pueda ser trabajada en 2 maquinas o mas pero con difernete usuario
    registroAutomatico: safeBool('registroAutomatico'),
    registroManual: safeBool('registroManual')

}